import React from "react";
import styles from "./StageSelector.module.css";
import { CustomButton } from "../../../../../../../../buttons";
import { translate } from "../../../../../../../../../providers";

const StageSelector = ({ stage, onChangeStage }) => (
	<div className={styles.container}>
		<CustomButton
			className={styles.buttonLeft}
			size="sm"
			variant={stage === 0 ? "contained" : "outlined"}
			onClick={() => {
				onChangeStage(0);
			}}
		>
			{translate("common:component.stage-selection.stage", { id: 1 })}
		</CustomButton>
		<CustomButton
			className={styles.buttonRight}
			size="sm"
			variant={stage === 1 ? "contained" : "outlined"}
			onClick={() => {
				onChangeStage(1);
			}}
		>
			{translate("common:component.stage-selection.stage", { id: 2 })}
		</CustomButton>
	</div>
);

export default StageSelector;
